import { render, staticRenderFns } from "./PercentageCircle.vue?vue&type=template&id=a1faabcc"
import script from "./PercentageCircle.vue?vue&type=script&lang=js"
export * from "./PercentageCircle.vue?vue&type=script&lang=js"
import style0 from "./PercentageCircle.vue?vue&type=style&index=0&id=a1faabcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports